import { useSelector } from '@xstate5/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const useIsLoggedIn = () => {
  const { authMachineRef } = useEssentialMachines();

  const isLoggedIn = useSelector(authMachineRef, (state) => {
    return state.matches({ session: 'loggedIn' });
  });

  return Boolean(isLoggedIn);
};
